import {
  DEFAULT_AXIS_LABEL_FONT_SIZE,
  LAST_LABEL_PADDING
} from "constants/chart.constants";
import { calculateTextDimensions } from "utils";

export const checkForOverlappingAndOutOfBoundsLabels = (
  dataToChartRatio: number,
  chartWidth: number,
  lastLabel: string,
  lastX: number,
  currentLabel: string,
  currentX: number,
  fontSize: number = DEFAULT_AXIS_LABEL_FONT_SIZE,
  rotation: number = 0
): boolean => {
  const lastPositionOfLabel = lastX / dataToChartRatio;
  const positionOfLabel = currentX / dataToChartRatio;

  if (rotation > 0) {
    const radians = (rotation * Math.PI) / 180;
    const cosRotation = Math.cos(radians);
    // Right-aligned rotated labels: right edge at tick, text extends left
    const currentProjectedWidth =
      calculateTextDimensions(currentLabel, fontSize).width * cosRotation;
    const labelOverlaps =
      lastPositionOfLabel + LAST_LABEL_PADDING > positionOfLabel - currentProjectedWidth;
    const labelExtendsBeyondChart = positionOfLabel > chartWidth;
    return labelOverlaps || labelExtendsBeyondChart;
  }

  const lastHalvedTextWidth = calculateTextDimensions(lastLabel, fontSize).width / 2;
  const lastLabelExtent = lastHalvedTextWidth + lastPositionOfLabel + LAST_LABEL_PADDING;

  const halvedTextWidth = calculateTextDimensions(currentLabel, fontSize).width / 2;
  const labelExtendsBeyondChart = positionOfLabel + halvedTextWidth > chartWidth;

  const labelOverlaps = lastLabelExtent > positionOfLabel - halvedTextWidth;
  return labelOverlaps || labelExtendsBeyondChart;
};
